import { Debt } from '../../interfaces';

export const getDebtsByAccountTypes = (debts: Debt[] = [], ...accountTypes: string[]): Debt[] =>
  debts.filter((debt) => accountTypes.includes(debt.accountType));
